`use strict`;

class Draad_Player {

    constructor(node, args) {

        this.node = node;
        this.args = args;

        this.init();

    }

    init() {

        if (this.args.platform === 'youtube') {

            window.YT.ready(this.initYoutube.bind(this));

        } else if (this.args.platform === 'vimeo') {

            this.waitForVimeoAPI();

        }

    }

    _vimeoLoadingFails = 0;
    waitForVimeoAPI(r) {

        if (this._vimeoLoadingFails > 10) {
            console.error('Vimeo API not loaded');
            return;
        }

        if (typeof Vimeo === 'undefined') {

            setTimeout(() => {

                this._vimeoLoadingFails++;
                this.waitForVimeoAPI();

            }, 100);

        } else {

            this.initVimeo();

        }

    }

    initYoutube() {

        // grep youtube video id from url using different formats
        if (this.args.src.includes('youtu.be')) {
            this.videoId = this.args.src.split('youtu.be/')[1];
        } else if (this.args.src.includes('embed')) {
            this.videoId = this.args.src.split('embed/')[1];
        } else if (this.args.src.includes('youtube.com')) {
            this.videoId = this.args.src.split('v=')[1];
        }

        this.player = new YT.Player(this.node.id, {
            videoId: this.videoId,
            playerVars: {
                'autoplay': this.args.autoplay,
                'cc_lang_pref': this.args.cc_lang_pref,
                'cc_load_policy': this.args.cc_load_policy,
                'color': this.args.color,
                'controls': this.args.controls,
                'disablekb': 1,
                'enablejsapi': 1,
                'fs': this.args.fs,
                'iv_load_policy': this.args.iv_load_policy,
                'loop': this.args.loop,
                'modestbranding': 1,
                'origin': this.args.origin,
                'playlist': this.videoId,
                'playsinline': this.args.playsinline,
                'rel': 0,
            },
            events: {
                'onReady': this.onYoutubePlayerReady.bind(this),
            },
        });

    }

    initVimeo() {

        this.player = new Vimeo.Player(this.node, {
            url: this.args.src,
            dnt: true,
            keyboard: false,
            quality: '4k',
            responsvie: true,
            autoplay: this.args.autoplay,
            texttrack: this.args.cc_lang_pref,
            controls: this.args.controls,
            loop: this.args.loop,
        });

        this.node = this.player.element;

        const playerWrapper = this.node.closest('.video__wrapper');
        const playButton = playerWrapper.querySelector(`[data-player-action="play"]`);

        if (playButton) {

            // play video on click
            playButton.addEventListener('click', (event) => {

                event.preventDefault();

                if (!this.player.getPaused()) {

                    this.player.pause();
                    playerWrapper.classList.remove('--playing');

                } else {

                    this.player.play();
                    playerWrapper.classList.add('--playing');

                }

            });

        }

    }

    onYoutubePlayerReady() {

        this.node = this.player.getIframe();

        const playerWrapper = this.node.closest('.video__wrapper');
        const playButton = playerWrapper.querySelector(`[data-player-action="play"]`);

        if (playButton) {

            // play video on click
            playButton.addEventListener('click', (event) => {

                event.preventDefault();

                if (this.player.getPlayerState() === 1) {

                    this.player.pauseVideo();
                    playerWrapper.classList.remove('--playing');

                } else {

                    this.player.playVideo();
                    playerWrapper.classList.add('--playing');

                }

            });

        }

    }

}

document.addEventListener('DOMContentLoaded', function () {

    const players = [];

    const playerNodes = document.querySelectorAll('.video__player');
    if (playerNodes) {
        for (const playerNode of playerNodes) {

            const attributes = playerNode.attributes;
            let attributesArray = Array.from(attributes);
            attributesArray = attributesArray.filter(attribute => {

                return (attribute.name.includes('data-player-')) ? true : false;

            });

            const attributesObject = {};
            if (attributesArray) {
                for (const attribute of attributesArray) {

                    const name = attribute.name.replace('data-player-', '');

                    attributesObject[name] = attribute.value;

                }
            }

            const player = new Draad_Player(playerNode, attributesObject);
            players.push(player);

        }
    }

});